import {useNavigate} from 'react-router-dom';
import './Login.css';
import loginImage from '../Assets/pexels-photo-7942528.jpeg';
import React, {useState, useEffect} from 'react';
import {FaEye, FaEyeSlash} from 'react-icons/fa';
import {Form, Input, Button, Spin, Row, Col, Typography, message, Card} from 'antd';
import logo from '../Assets/Edumonics-Logo.png';

function Login() {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [passwordShown, setPasswordShown] = useState(false);

    const togglePasswordVisibility = () => {
        setPasswordShown(!passwordShown);
    };

    useEffect(() => {
        if (isLoggedIn) {
            navigate('/HomePage');
        }
    }, [isLoggedIn, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setErrorMessage('');

        try {
            const response = await fetch('https://api.edumonics.in/login/admin', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    'username': email,
                    'password': password
                })
            });

            const data = await response.json();
            if (!response.ok) {
                message.error(data.detail || "Login failed!");
                setIsLoading(false);
                return;
            }

            localStorage.setItem('accessToken', data.access_token);
            // console.log("access token :", data.access_token);
            setIsLoading(false);
            message.success('Login successful!');

            // Call initializeChatbot here, make sure to pass navigate as an argument
            // await initializeChatbot();

            setIsLoggedIn(true);  // Only set if login and initialization are successful
        } catch (error) {
            setErrorMessage("Login Failed: " + error.message);
            console.error("Login Error:", error);
        } finally {
            setIsLoading(false);
        }
    };

    // const initializeChatbot = async () => {
    //     const accessToken = localStorage.getItem('accessToken');
    //     if (!accessToken) {
    //         throw new Error("No access token found. Please login or sign up.");
    //     }
    //
    //     const initResponse = await fetch('https://api.edumonics.in/initialize_model', {
    //         method: 'POST',
    //         headers: {
    //             'Authorization': `Bearer ${accessToken}`,
    //         },
    //     });
    //
    //     if (!initResponse.ok) {
    //         if (initResponse.status === 401) {
    //             // localStorage.removeItem('accessToken');
    //             // navigate('/');
    //             throw new Error("You are not Authorized to Login");
    //         } else {
    //             throw new Error(`Failed to initialize the model: ${initResponse.statusText}`);
    //         }
    //     }
    // };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-image-container">
                    <img src={loginImage} alt="Login" className="login-image"/>
                </div>
                <form className="login-form" onSubmit={handleSubmit}>
                    {/*<h1>Admin Panel</h1>*/}
                    <img src={logo} alt="logo"/>
                    <h1>HPC CogniApp - For Principals</h1>
                    <input
                        type="email"
                        placeholder="Email"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <div className="password-field">
                        <input
                            type={passwordShown ? 'text' : 'password'}
                            placeholder="Password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <i onClick={togglePasswordVisibility}
                           style={{position: 'absolute', right: '15px', top: '49%', transform: 'translateY(-50%)'}}>
                            {passwordShown ? <FaEye/> : <FaEyeSlash/>}
                        </i>
                    </div>
                    <div className="signup-action-container">
                        <button type="submit" className="signup-btn" disabled={isLoading}>Login</button>
                        {isLoading && <div className="loader"></div>}
                    </div>
                    {/*{errorMessage && <div className="error-message">{errorMessage}</div>}*/}
                </form>
            </div>
        </div>
    );
}

export default Login;
